import type { SVGProp } from './types';

export const copy = (props: SVGProp) => (
  <svg
    width={props.width || '24'}
    height={props.height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M21 8.94c-.0104-.09187-.0305-.18237-.06-.27v-.09c-.0481-.10282-.1122-.19733-.19-.28l-6-6c-.0827-.07778-.1772-.14192-.28-.19-.0298-.00424-.0601-.00424-.09 0-.1016-.05826-.2138-.09566-.33-.11H10c-.79565 0-1.55871.31607-2.12132.87868C7.31607 3.44129 7 4.20435 7 5v1H6c-.79565 0-1.55871.31607-2.12132.87868C3.31607 7.44129 3 8.20435 3 9v10c0 .7956.31607 1.5587.87868 2.1213C4.44129 21.6839 5.20435 22 6 22h8c.7956 0 1.5587-.3161 2.1213-.8787C16.6839 20.5587 17 19.7956 17 19v-1h1c.7956 0 1.5587-.3161 2.1213-.8787C20.6839 16.5587 21 15.7956 21 15V9c0 0 0 0 0-.06Zm-6-3.53L17.59 8H16c-.2652 0-.5196-.10536-.7071-.29289C15.1054 7.51957 15 7.26522 15 7V5.41ZM15 19c0 .2652-.1054.5196-.2929.7071-.1875.1875-.4419.2929-.7071.2929H6c-.26522 0-.51957-.1054-.70711-.2929C5.10536 19.5196 5 19.2652 5 19V9c0-.26522.10536-.51957.29289-.70711C5.48043 8.10536 5.73478 8 6 8h1v7c0 .7956.31607 1.5587.87868 2.1213C8.44129 17.6839 9.20435 18 10 18h5v1Zm4-4c0 .2652-.1054.5196-.2929.7071-.1875.1875-.4419.2929-.7071.2929h-8c-.26522 0-.51957-.1054-.70711-.2929C9.10536 15.5196 9 15.2652 9 15V5c0-.26522.10536-.51957.29289-.70711C9.48043 4.10536 9.73478 4 10 4h3v3c0 .79565.3161 1.55871.8787 2.12132C14.4413 9.68393 15.2044 10 16 10h3v5Z"
      fill="currentColor"
    />
  </svg>
);
